import React, { useState } from "react";
import { useData } from "@/context/DataContext";
import { PageTitle, Fab, RowActions, EmptyState } from "@/components/shared";
import DataDialog from "@/components/DataDialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { toast } from "sonner";

function RundownTable({ items, onEdit, onDelete }) {
  if (items.length === 0) return <EmptyState />;
  const sorted = [...items].sort((a, b) => (a.jam || "").localeCompare(b.jam || ""));
  return (
    <div className="rounded-xl border border-border">
      <Table>
        <TableHeader><TableRow>
          <TableHead>Jam</TableHead><TableHead>Kegiatan</TableHead><TableHead>PIC</TableHead>
          <TableHead>Keterangan</TableHead><TableHead className="text-right">Aksi</TableHead>
        </TableRow></TableHeader>
        <TableBody>
          {sorted.map((i) => (
            <TableRow key={i.id} data-testid={`row-${i.id}`}>
              <TableCell className="font-semibold">{i.jam || "-"}</TableCell>
              <TableCell>{i.kegiatan}</TableCell>
              <TableCell>{i.pic || "-"}</TableCell>
              <TableCell className="text-muted-foreground">{i.keterangan || "-"}</TableCell>
              <TableCell><RowActions id={i.id} onEdit={() => onEdit(i)} onDelete={() => onDelete(i.id)} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default function Rundown() {
  const { data, create, update, remove } = useData();
  const items = data.rundown || [];
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const fields = [
    { name: "acara", label: "Acara", type: "select", options: ["Lamaran", "Nikah"], required: true },
    { name: "kegiatan", label: "Kegiatan", type: "text", required: true },
    { name: "jam", label: "Jam", type: "time", required: true },
    { name: "keterangan", label: "Keterangan", type: "textarea" },
    { name: "pic", label: "PIC", type: "text" },
  ];

  const onSave = async (payload) => {
    if (editing) { await update("rundown", editing.id, payload); toast.success("Rundown diperbarui"); }
    else { await create("rundown", payload); toast.success("Rundown ditambahkan"); }
  };

  return (
    <div>
      <PageTitle title="Rundown Acara" subtitle="Susunan acara diurutkan berdasarkan jam" />
      <Tabs defaultValue="Nikah">
        <TabsList>
          <TabsTrigger value="Lamaran" data-testid="tab-lamaran">Lamaran</TabsTrigger>
          <TabsTrigger value="Nikah" data-testid="tab-nikah">Pernikahan</TabsTrigger>
        </TabsList>
        <TabsContent value="Lamaran"><RundownTable items={items.filter((i) => i.acara === "Lamaran")} onEdit={(i) => { setEditing(i); setOpen(true); }} onDelete={(id) => remove("rundown", id)} /></TabsContent>
        <TabsContent value="Nikah"><RundownTable items={items.filter((i) => i.acara === "Nikah")} onEdit={(i) => { setEditing(i); setOpen(true); }} onDelete={(id) => remove("rundown", id)} /></TabsContent>
      </Tabs>
      <Fab testId="fab-rundown" onClick={() => { setEditing(null); setOpen(true); }} />
      <DataDialog open={open} onOpenChange={setOpen} title={editing ? "Edit Rundown" : "Tambah Rundown"} fields={fields} initial={editing} onSave={onSave} />
    </div>
  );
}
